export default __webpack_public_path__ + "static/media/aboutUsImage.aba8667f.jpg";